import { Injectable } from "@angular/core";

@Injectable()
export class ApiReturn 
{
  public AmbitFeatureId:string = "";
  public ApiAdditionalInfo:string = "";
  public ApiAuthenticatedFlag:string = "";
  public FunctionName:string = "";
  public ApiLogId:string = "";
  public ApiMilliseconds:string = "";
  //public ApiSeconds:string = "";
  public ApiReturnCode:string = "";
  public ApiReturnText:string = "";
  public ApiSuccessCode:string = "";
  public ApiSuccessFlag:boolean = false;
  public ApiVersion:string = "";
  public Description:string = "";
  public StartDatetimeUtc:string = "";
  public EndDatetimeUtc:string = "";

  public ApiLogDate:string = "";

  Initialize()
  {
    this.AmbitFeatureId = "";
    this.ApiAdditionalInfo = "";
    this.ApiAuthenticatedFlag = "";
    this.FunctionName = "";
    this.ApiLogId = "";
    this.ApiMilliseconds = "";
    //this. ApiSeconds = "";
    this.ApiReturnCode = "";
    this.ApiReturnText = "";
    this.ApiSuccessCode = "";
    this.ApiSuccessFlag = false;
    this.ApiVersion = "";
    this.Description = "";
    this.StartDatetimeUtc = "";
    this.EndDatetimeUtc = "";

    this.ApiLogDate = "";
  }

  SetApiReturn(apiReturn:any)
  {
    // console.log("apiReturn.SetApiReturn", apiReturn);
    if (!apiReturn) { return; }

    if (apiReturn.AmbitFeatureId) { this.AmbitFeatureId = apiReturn.AmbitFeatureId; }
    if (apiReturn.ApiAdditionalInfo) { this.ApiAdditionalInfo = apiReturn.ApiAdditionalInfo; }
    if (apiReturn.ApiAuthenticatedFlag) { this.ApiAuthenticatedFlag = apiReturn.ApiAuthenticatedFlag; }
    if (apiReturn.FunctionName) { this.FunctionName = apiReturn.FunctionName; }
    if (apiReturn.ApiLogId) { this.ApiLogId = apiReturn.ApiLogId; }
    if (apiReturn.ApiReturnCode) { this.ApiReturnCode = apiReturn.ApiReturnCode; }
    if (apiReturn.ApiReturnText) { this.ApiReturnText = apiReturn.ApiReturnText; }
    if (apiReturn.ApiSuccessCode) { this.ApiSuccessCode = apiReturn.ApiSuccessCode; }
    if (apiReturn.ApiSuccessFlag) { this.ApiSuccessFlag = apiReturn.ApiSuccessFlag; }
    if (apiReturn.ApiVersion) { this.ApiVersion = apiReturn.ApiVersion; }
    if (apiReturn.Description) { this.Description = apiReturn.Description; }
    if (apiReturn.StartDatetimeUtc) { this.StartDatetimeUtc = apiReturn.StartDatetimeUtc; }
    if (apiReturn.EndDatetimeUtc) { this.EndDatetimeUtc = apiReturn.EndDatetimeUtc; }

    if (apiReturn.ApiMilliseconds) 
    { 
      this.ApiMilliseconds = apiReturn.ApiMilliseconds; 
      //this.ApiSeconds = Math.floor(this.ApiMilliseconds / 1000);
    }

    if (apiReturn.EndDatetimeUtc) 
    { 
      this.ApiLogDate = apiReturn.EndDatetimeUtc; 
    }
    else if (apiReturn.StartDatetimeUtc)
    {
      this.ApiLogDate = apiReturn.StartDatetimeUtc; 
    }
    else
    {
      // ToDo:  set to moment utc date
      this.ApiLogDate = "";
    }
  }

  SetAndGetApiReturn(apiReturn:any):ApiReturn
  {
    this.SetApiReturn(apiReturn);
    return this;
  }
}

@Injectable()
export class ApiResponse
{
  // use this as a dummy ApiResponse when the API fails to respond
  public ApiReturn:ApiReturn = new ApiReturn();
}
